module.exports = __webpack_public_path__ + "static/media/hero-cv-4.cd284b4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/audio/hero-cv-4.mp3
// module id = 1Gso
// module chunks = 13